import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import './styles/post.css';
import { useEffect, useState } from 'react';

function Post (props)
{
    return(
        <div>
            {props.msg.map((value, key)=> { 
                if(value.unsend || key == 0)
                    return;
                const send_by = value.sender == props.user_email;
            return(
                <Card id="post" style={{backgroundColor:'burlywood', marginTop: 10, marginBottom: 10, width: '18rem', marginLeft: send_by ? (props.RWD ? 0 : 650 ): 0}} >
                    <Card.Body>
                        <div style={{display: 'flex', marginBottom: 10}}>
                        <Card.Img src='img/user.png' variant='top' style={{height: 32 , width:32} }/>
                        <Card.Subtitle style={{marginTop : 7, marginLeft: 10}}>{value.sender}</Card.Subtitle>
                        </div>
                        <div style={{display: 'flex', marginBottom: 10}}>
                            <div>
                            {value.type == 0 ? (value.sender == props.user_email ? 
                                <Card Body className="send_by_me" >
                                    <Card.Text>{value.data}</Card.Text>
                                </Card> : 
                                <Card Body className="send_by_others" style={{backgroundColor: 'grey'}} >
                                    <Card.Text>{value.data}</Card.Text>
                                </Card>): (value.type == 1 ? (value.data && <Card.Img src={value.data}></Card.Img>) : <video width="320" height="240" controls>{ (value.data && <source src={value.data} type="video/mp4"></source>)}</video>)}
                            </div>
                            <div>
                                {value.sender == props.user_email ? <Button size="sm" className="unsend" onClick={() => {props.handle_unsend(key)}} >unsend</Button>: null}
                            </div>
                                
                        </div>
                        
                    </Card.Body>
                </Card>
            );
        })}
        </div>
        
    
)
    
}
export default Post;